import { create } from 'zustand'

export type TankToRemove = {
  tankId: string
  tankName: string
  schoolId: string
}

type HomeRemoveGroupState = {
  // Step 1: Selected group
  selectedGroupId: string | null
  selectedGroupName: string | null
  selectGroupBorderColor: string

  // Step 2: Tanks in selected group & tanks to remove
  tanksInGroup: TankToRemove[]
  selectedTanksToRemove: TankToRemove[]
  selectTanksBorderColor: string
}

type HomeRemoveGroupAction = {
  setSelectedGroup: (groupId: string, groupName: string) => void
  setTanksInGroup: (tanks: TankToRemove[]) => void
  toggleTankSelection: (tank: TankToRemove) => void
  setGroupBorderColor: () => void
  setTanksBorderColor: () => void
  reset: () => void
}

const initialState: HomeRemoveGroupState = {
  selectedGroupId: null,
  selectedGroupName: null,
  selectGroupBorderColor: 'border border-tdpldarkgrey',
  tanksInGroup: [],
  selectedTanksToRemove: [],
  selectTanksBorderColor: 'border border-tdpldarkgrey',
}

const useHomeRemoveGroupStore = create<HomeRemoveGroupState & HomeRemoveGroupAction>((set) => ({
  ...initialState,

  setSelectedGroup: (groupId, groupName) => {
    set(() => ({
      selectedGroupId: groupId,
      selectedGroupName: groupName,
      selectGroupBorderColor: 'border border-tdpldarkgrey',
      // Reset tank selection when group changes
      selectedTanksToRemove: [],
    }))
  },

  setTanksInGroup: (tanks) => {
    set(() => ({
      tanksInGroup: tanks,
    }))
  },

  toggleTankSelection: (tank) => {
    set((state) => {
      const isSelected = state.selectedTanksToRemove.some((t) => t.tankId === tank.tankId)
      if (isSelected) {
        return {
          selectedTanksToRemove: state.selectedTanksToRemove.filter((t) => t.tankId !== tank.tankId),
          selectTanksBorderColor: 'border border-tdpldarkgrey',
        }
      } else {
        return {
          selectedTanksToRemove: [...state.selectedTanksToRemove, tank],
          selectTanksBorderColor: 'border border-tdpldarkgrey',
        }
      }
    })
  },

  setGroupBorderColor: () => {
    set((state) => ({
      selectGroupBorderColor:
        state.selectedGroupId !== null
          ? 'border border-tdpldarkgrey'
          : 'border-2 border-tdplmaroon',
    }))
  },

  setTanksBorderColor: () => {
    set((state) => ({
      selectTanksBorderColor:
        state.selectedTanksToRemove.length > 0
          ? 'border border-tdpldarkgrey'
          : 'border-2 border-tdplmaroon',
    }))
  },

  reset: () => {
    set(initialState)
  },
}))

export default useHomeRemoveGroupStore
